import {
    createStyles,
    CSSObject,
    getStylesRef,
    NavLinkStylesNames,
} from '@mantine/core';

export const useMenuStyles = createStyles<NavLinkStylesNames>(
    //Definir Record<NavLinkStylesNames, CSSObject> ayuda a poner los nombres correctos en el menu de abajo
    (theme): Record<NavLinkStylesNames, CSSObject> => {
        return {
            /**
             * Esto es una flecha que se dibuja para abrir el submenu.
             * La quito por acá porque por props no hay opción.
             * Y la quito porque me rompe con el diseño actual (además no hace falta)
             */
            rightSection: {
                display: 'none',
            },
            root: {
                ['&.active']: {
                    [`& .${getStylesRef('menuItemLabel')}`]: {
                        color: theme.colors.doradoLuker[4],
                    },
                    [`& .${getStylesRef('menuItemIcon')}`]: {
                        ['& svg']: {
                            color: theme.colors.doradoLuker[4],
                            //Si usamos stroke más abajo (menuItemIcon & svg) hay que usarlo acá también
                            stroke: theme.colors.doradoLuker[4],
                        },
                    },
                },
                [`&:hover`]: {
                    backgroundColor: 'inherit',
                },
                [`&:hover .${getStylesRef('menuItemLabel')}`]: {
                    color: 'white',
                    fontWeight: 800,
                },
                [`&:hover .${getStylesRef('menuItemIcon')}`]: {
                    ['& svg']: {
                        stroke: 'white',
                    },
                },
                //estaba en 10 acá, pero con muchos items ya me parece mucho
                margin: '3px 0 ',
            },
            body: {},
            icon: {
                ref: getStylesRef('menuItemIcon'),
                ['& svg']: {
                    width: 25,
                    height: 25,
                    color: theme.colors.celesteLuker[1],
                    //Si sacamos este stroke, los íconos se ven más finitos... parece que los dibuja 2 veces
                    stroke: theme.colors.celesteLuker[1],
                },
            },
            label: {
                // backgroundColor: '#384FA1',
                // color: 'red',// assign reference to selector
                ref: getStylesRef('menuItemLabel'),
                color: theme.colors.celesteLuker[1],
                fontSize: '12px',
                fontWeight: 'bold',
                lineHeight: '30px',
                // ...(theme.fn.hover({
                //     color: theme.colors.celesteLuker[9],
                // }) as CSSObject),
                // '&:hover': {
                //     color: theme.colors.celesteLuker[9],
                // },
            },
            children: {
                paddingLeft: 20,
            },
            description: {},
        };
    }
);
